module.exports = __webpack_public_path__ + "media/images/emoticons/rvcar-a20245e7420f0db0ebc20e78cd51af0e.gif";